import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import MypageGenre from '../MypageGenre';
import api from '../../../../api/api';
import NoUser from './NoUser';

import useConfirmLeave from '../../../../hooks/useConfirmLeave';
import { ModalOneBtn, ModalTwoBtns } from '../../../../components/modals';

import { FormState } from '@/types/mypage/EditProfileType';
import { ImagesUploader } from '../form';

const ProfileDancer = () => {
  const navigate = useNavigate();
  const [formState, setFormState] = useState<FormState>({
    name: '',
    instagram: '',
    chatting: '',
    introduce: '',
    genre: [],
    record: '',
    dancerImages: ['', '', '']
  });
  const [isUnauthorized, setIsUnauthorized] = useState<boolean>(false);
  const [showLeaveAlert, setShowLeaveAlert] = useState<boolean>(false);
  const [showInvalidAlert, setShowInvalidAlert] = useState<boolean>(false);
  const [showImageRequiredAlert, setShowImageRequiredAlert] = useState<boolean>(false);

  // 뒤로 가기 방지 팝업 경고
  useConfirmLeave({ setAlert: setShowLeaveAlert });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await api.get('/dancers', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
    
        const data = response.data.data;

        const preferredGenres = data.preferredGenres;
        const genreInitial =
          preferredGenres == null || preferredGenres.length === 0
            ? [11]
            : preferredGenres;

        setFormState({
          name: data.dancerName || '',
          instagram: data.instargramId || '',
          chatting: data.openChatUrl || '',
          introduce: data.bio || '',
          genre: genreInitial,
          record: data.history || '',
          dancerImages: data.dancerImages || []
        });
      } catch (error: any) {
        console.error('Error fetching data:', error);
        if (error.response && error.response.status === 401) {
          setIsUnauthorized(true);
        }
      }
    };
    fetchData();
  }, []);

  if (isUnauthorized) {
    return <NoUser />;
  }

  const handleFormChange = (
    key: keyof FormState,
    value: string | string[] | number[] | File[]
  ) => {
    setFormState((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const dancerImages = formState.dancerImages.filter((img) => Boolean(img));

    if (dancerImages.length < 1) {
      setShowImageRequiredAlert(true);
      return;
    }

    try {
      const token = localStorage.getItem('token');

      const updatedData = {
        dancerName: formState.name,
        instargramId: formState.instagram,
        openChatUrl: formState.chatting,
        bio: formState.introduce,
        preferredGenres: formState.genre,
        history: formState.record,
        dancerImages
      };

      const response = await api.put('/dancers', updatedData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response.status === 200) {
        console.log('업데이트 성공');
        console.log(updatedData);
        setShowInvalidAlert(true);
      } else {
        console.error('업데이트 에러 발생');
      }
    } catch (error) {
      console.error('업데이트 에러', error);
    }
  };

  const getPreview = (images: (File | string)[]): (string | undefined)[] => {
    if (!images || images.length === 0) return [];

    return images.map((image) => {
      if (image instanceof File) {
        return URL.createObjectURL(image);
      }
      return image;
    });
  };

  return (
    <AllContainer>
      <Container>
        <ItemContainer>
          <DancerNameContainer>
            <Label> 댄서 네임 </Label>
            <Input
              type="text"
              placeholder="댄서 네임을 입력하세요"
              value={formState.name}
              onChange={(e) => handleFormChange('name', e.target.value)}
            />
          </DancerNameContainer>

          <InstaContainer>
            <Label> Instagram 아이디 </Label>
            <Input
              type="text"
              placeholder="Instagram 아이디를 입력하세요"
              value={formState.instagram}
              onChange={(e) => handleFormChange('instagram', e.target.value)}
            />
          </InstaContainer>

          <OpenChatContainer>
            <OpenChatItemContainer>
              <Label> 오픈채팅방 링크 </Label>
              <Text>
                {' '}
                *유저들과의 채팅이 이루어질 오픈채팅방 링크를 입력해주세요{' '}
              </Text>
            </OpenChatItemContainer>
            <Input
              type="link"
              placeholder="카카오톡 오픈채팅방 링크를 입력하세요"
              value={formState.chatting}
              onChange={(e) => handleFormChange('chatting', e.target.value)}
            />
          </OpenChatContainer>

          <IntroContainer>
            <Label> 한마디 소개글 </Label>
            <Input
              type="text"
              placeholder="한 마디 소개글을 입력하세요"
              value={formState.introduce}
              onChange={(e) => handleFormChange('introduce', e.target.value)}
            />
          </IntroContainer>

          <GenreContainer>
            <OpenChatItemContainer>
              <Label> 장르 </Label>
              <Text> * 최대 2개까지 선택 가능합니다 </Text>
            </OpenChatItemContainer>
            <MypageGenre
              genreSelect={2}
              selectedGenres={formState.genre}
              onGenreChange={(selectedGenres) => {
                handleFormChange('genre', selectedGenres);
              }}
            />
          </GenreContainer>

          <DancerRecord>
            <Label> 댄서 이력 </Label>
            <WriteInput
              placeholder="댄서 이력을 입력하세요"
              value={formState.record}
              onChange={(e) => handleFormChange('record', e.target.value)}
            />
          </DancerRecord>

          <DancerPictureContainer>
            <OpenChatItemContainer>
              <Label> 댄서 사진 </Label>
              <SmallTextContainer>
                <SmallText>* 최대 3장까지 등록 가능합니다</SmallText>
                <SmallText>
                  * 가장 첫 번째로 등록된 사진이 프로필로 사용됩니다
                </SmallText>
              </SmallTextContainer>
            </OpenChatItemContainer>
            <ImagesUploader
              isFor="dancer"
              images={(() => {
                const preview = getPreview(formState.dancerImages).filter(
                  (v): v is string => v !== undefined
                );
                const padded = [...preview];
                while (padded.length < 3) padded.push('');
                return padded.slice(0, 3);
              })()}
              handleFormChange={handleFormChange}
            />
          </DancerPictureContainer>
        </ItemContainer>
      </Container>
      <SaveButton onClick={handleSubmit}> 프로필 저장 </SaveButton>
      {showInvalidAlert && (
        <ModalOneBtn
          message={<AlertText>프로필 저장이 완료되었습니다.</AlertText>}
          onClose={() => setShowInvalidAlert(false)}
          showButtons={true}
        />
      )}
      {showImageRequiredAlert && (
        <ModalOneBtn
          message={
            <AlertText>
              댄서 사진은 최소 1장 이상{'\n'}등록해주세요.
            </AlertText>
          }
          onClose={() => setShowImageRequiredAlert(false)}
          showButtons={true}
        />
      )}
      {showLeaveAlert && (
        <ModalTwoBtns
          message={
            <AlertText>
              해당 페이지를 벗어나면{'\n'}
              작성 중인 정보가 <ColoredText> 모두 삭제</ColoredText>됩니다.
              {'\n'}
              떠나시겠습니까?
            </AlertText>
          }
          onClose={() => setShowLeaveAlert(false)}
          onSecondaryClick={() => navigate('/mypage')}
          showButtons={true}
          primaryLabel="남기"
          secondaryLabel="떠나기"
        />
      )}
    </AllContainer>
  );
};

export default ProfileDancer;

const AllContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: 600px) {
    width: 100%;
  }
`;
const Container = styled.div`
  width: 900px;
  flex-shrink: 0;
  border-radius: 25px;
  border: 2px solid #9819c3;
  display: flex;
  justify-content: center;
  padding-bottom: 56px;

  @media (max-width: 600px) {
    width: 100%;
    height: auto;
    padding: 20px 0 28px;
    border: none;
    border-radius: 0;
  }
`;

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;

  @media (max-width: 600px) {
    width: 100%;
  }
`;
const DancerNameContainer = styled.div`
  margin-top: 58px;

  @media (max-width: 600px) {
    margin-top: 24px;
  }
`;

const Label = styled.div`
  color: white;
  font-size: 22px;
  font-weight: 600;
  line-height: normal;

  @media (max-width: 600px) {
    font-size: 18px;
  }
`;

const Input = styled.input`
  display: flex;
  width: 588px;
  height: 60px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-color: #000;
  border: 1px solid #dddddd;
  border-radius: 8px;
  color: white;
  font-size: 20px;
  margin-top: 10px;
  padding-left: 31px;

  &::placeholder {
    color: #ddd;
    font-size: 20px;
    font-weight: 300;
    line-height: normal;
    font-style: normal;
  }

  @media (max-width: 600px) {
    width: 100%;
    height: 50px;
    font-size: 16px;
    padding-left: 16px;

    &::placeholder {
      font-size: 16px;
    }
  }
`;

const InstaContainer = styled.div`
  margin-top: 27px;

  @media (max-width: 600px) {
    margin-top: 20px;
  }
`;

const OpenChatContainer = styled.div`
  margin-top: 27px;

  @media (max-width: 600px) {
    margin-top: 20px;
  }
`;

const OpenChatItemContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 600px) {
    flex-direction: row;
    margin-bottom: 12px;
  }
`;

const Text = styled.div`
  color: #b2b2b2;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin-left: 20px;
  margin-top: 7px;

  @media (max-width: 600px) {
    font-size: 12px;
    margin-left: 0;
    margin-top: 4px;
  }
`;

const IntroContainer = styled.div`
  margin-top: 44px;

  @media (max-width: 600px) {
    margin-top: 30px;
  }
`;

const GenreContainer = styled.div`
  margin-top: 44px;

  @media (max-width: 600px) {
    margin-top: 30px;
  }
`;

const DancerRecord = styled.div`
  margin-top: 59px;
  display: flex;
  flex-direction: column;

  @media (max-width: 600px) {
    margin-top: 30px;
  }
`;

const WriteInput = styled.textarea`
  display: flex;
  width: 588px;
  height: 466px;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 0;
  background-color: transparent;
  border: 1px solid #dddddd;
  border-radius: 8px;
  color: white;
  font-size: 20px;
  margin-top: 10px;
  resize: none;
  padding: 17px 16px 0 18px;

  &::placeholder {
    color: #ddd;
    font-size: 20px;
    font-weight: 300;
    line-height: normal;
    font-style: normal;
  }

  @media (max-width: 600px) {
    width: 100%;
    height: 300px;
    font-size: 16px;
    padding: 12px 16px 0 14px;

    &::placeholder {
      font-size: 16px;
    }
  }
`;

const DancerPictureContainer = styled.div`
  margin-top: 45px;
  width: 616px;

  @media (max-width: 600px) {
    width: 100%;
    margin-top: 30px;
  }
`;

const SmallTextContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 765px) {
    flex-direction: column;
    margin-left: 20px;
  }
`;

const SmallText = styled.div`
  color: #b2b2b2;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin-left: 20px;

  @media (max-width: 600px) {
    font-size: 12px;
    margin-left: 0;
    margin-top: 4px;

    &:first-child {
      margin-top: 0;
    }
  }
`;

const SaveButton = styled.button`
  width: 300px;
  height: 52px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  background-color: #9819c3;
  border: none;
  color: white;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-top: 45px;
  margin-bottom: 92px;
  cursor: pointer;

  @media (max-width: 600px) {
    width: 100%;
    height: 48px;
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 46px;
  }
`;

const AlertText = styled.span`
  text-align: center;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  white-space: pre-line;

  ${({ theme }) => theme.media.tablet} {
    font-size: 16px;
  }
`;

const ColoredText = styled.span`
  color: #a60f62;
  font-weight: bold;
`;
